export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/auth/Login.vue'),
        meta: {
            title: 'Login',
        },
    },
    {
        path: '/password/reset',
        name: 'password.request',
        component: () => import('@/pages/auth/ForgotPassword.vue'),
        meta: {
            title: 'Forgot Password',
        },
    },
    {
        path: '/password/reset/:token',
        name: 'password.reset',
        component: () => import('@/pages/auth/ResetPassword.vue'),
        meta: {
            title: 'Reset Password',
        },
        props: true, // Pass route params as props
    },
    {
        path: '/password/change',
        name: 'password.change',
        component: () => import('@/pages/auth/ChangePassword.vue'),
        meta: {
            title: 'Change Password',
        },
    },
];
